import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const ExperienceSection = styled.div`
    padding-top: .5rem;
    >h4{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.fourth};
    }
`
export const ExperienceCard = styled.div`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    div:last-child{
        margin-bottom:0rem
    }
`
export const Organization = styled(Row)`
    margin-bottom:.5rem;
`
export const Schedule = styled(Col)`
    span{
        font-family:${({ theme }) => theme.font.second};
        color: ${({ theme }) => theme.color.sixth};
        font-weight:400;
    }
`
export const OrganizationDetails = styled(Col)`
    >p:last-child{
        margin-bottom:0rem;
    }
    >p{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.second};
        font-weight:400;
        color: ${({ theme }) => theme.color.fourth};
        text-align: justify;
    }
    

`
export const OrganizationTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .5rem;
    >span{
        color: ${({ theme }) => theme.color.first};
        font-size:10px;
        padding: 4px;
        border-radius:5px;
        background-color: ${({ theme }) => theme.color.second};
    }
    >h3{
        font-family:${({ theme }) => theme.font.first};
        font-weight:500;
        color: ${({ theme }) => theme.color.sixth};
        span{
            color: ${({ theme }) => theme.color.first};
        }
    }

`